import React from 'react';
import { reduxForm, FieldArray } from 'redux-form';
import { Button } from 'react-bootstrap';
import RenderLists from './Helper/RenderLists';

class NewSaleReturnForm extends React.Component {

   render() {
      const { handleSubmit, items, submitting, pristine, invalid, submit, error } = this.props;
      return (
         <form noValidate="true"
               autoComplete="off" onSubmit={handleSubmit(submit)} >
            <FieldArray items={items} name="items" component={RenderLists} />
            {error && <strong className="input-validation-error" >{error}</strong>}

            <Button type="submit" bsStyle="success" block
                    disabled={submitting || pristine || invalid} >Save</Button>
         </form>
      );
   }
}


NewSaleReturnForm.propTypes = {
   handleSubmit: React.PropTypes.func,
   submit: React.PropTypes.func,
   items: React.PropTypes.array,
   submitting: React.PropTypes.bool,
   pristine: React.PropTypes.bool,
   invalid: React.PropTypes.bool,
   error: React.PropTypes.object,
};

NewSaleReturnForm = reduxForm({ // eslint-disable-line
   form: 'newSaleReturnForm'
})(NewSaleReturnForm);
export default NewSaleReturnForm;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/SaleReturn/NewSaleReturnForm.js
 **/